// extracted by mini-css-extract-plugin
export default {"price":"y8-z","priceRow":"z8-z","onSale":"A8-z","msrpLabelPrice":"B8-z","msrpLabel":"C8-z","originalPrice":"D8-z","percentOff":"E8-z"};